export default __webpack_public_path__ + "static/media/invalid.3dd93b56.wav";